export default "__VITE_ASSET__5fc8932d__"